// extracted by mini-css-extract-plugin
export default {"containerWrapper":"CardSellersContainer_containerWrapper__GW2Kd","slider":"CardSellersContainer_slider__O04k6","cardWrapper":"CardSellersContainer_cardWrapper__u38fw"};